import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReactToPrint } from "react-to-print";
import NavbarLoc from "./NavbarLoc";
import Footer from "../Footer";

export default function DetailLocataire() {
  const { id } = useParams();
  const [person, setPerson] = useState({ homeId: {}, rentals: [] });
  const [works, setWorks] = useState([]);
  const [documents, setDocuments] = useState({ CNI: null, Contrat: null });
  const [loading, setLoading] = useState(true);
  const [openYears, setOpenYears] = useState({});
  const [showWorkModal, setShowWorkModal] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [workForm, setWorkForm] = useState({
    title: "",
    description: "",
    attachments: [],
  });

  const componentRef = useRef();

  // ✅ Ouvre / ferme le modal
  const toggleModal = () => setShowWorkModal((prev) => !prev);

  // ✅ Gestion du changement d’image
  const handleFileChange = (e) => {
    setWorkForm({ ...workForm, attachments: Array.from(e.target.files) });
  };

  // ✅ Envoi de la notification de réparation
  const handleSubmitWork = async (e) => {
    e.preventDefault();

    if (!workForm.title.trim()) {
      toast.warning("Veuillez indiquer un titre du problème.");
      return;
    }

    const formData = new FormData();
      formData.append("personId", id);
      formData.append("homeId", person?.homeId?._id);
      formData.append("adminId", person?.homeId?.ownerId);
      formData.append("title", workForm.title);
      formData.append("description", workForm.description);
      formData.append("createdBy", `${person?.name || ""} ${person?.prenom || ""}`.trim());
      workForm.attachments.forEach((file) => formData.append("attachments", file));

    try {
      const res = await fetch(`https://backend-ged-immo.onrender.com/works/report`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (res.ok) {
        toast.success("Votre demande de réparation a été envoyée ✅");
        setShowWorkModal(false);
        setWorkForm({ title: "", description: "", attachments: [] });
      } else {
        toast.error(data.message || "Erreur lors de l’envoi de la demande.");
      }
    } catch (err) {
      console.error("Erreur envoi réparation:", err);
      toast.error("Erreur serveur lors de l’envoi.");
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: person.name || "Détails locataire",
  });

  const formatDate = (d) => {
    if (!d) return "N/A";
    const date = new Date(d);
    return isNaN(date) ? d : date.toLocaleDateString("fr-FR");
  };

  const toggleYear = (year) => {
    setOpenYears((prev) => ({ ...prev, [year]: !prev[year] }));
  };

  // 🔹 Récupération loyers payés
  const fetchRents = async () => {
    try {
      const res = await fetch(`https://backend-ged-immo.onrender.com/rents/${id}`);
      const data = await res.json();
      if (res.ok && data.success) {
        setPerson((prev) => ({ ...prev, rentals: data.rents || [] }));
      } else {
        setPerson((prev) => ({ ...prev, rentals: [] }));
      }
    } catch (err) {
      console.error("Erreur fetchRents:", err);
      toast.error("Impossible de récupérer les loyers du locataire");
    }
  };

const fetchWorks = async () => {
  try {
    const res = await fetch(`https://backend-ged-immo.onrender.com/works/locataire/${id}`);
    const data = await res.json();
    if (res.ok && data.success) setWorks(data.works || []);
  } catch (err) {
    console.error("Erreur fetchWorks:", err);
    toast.error("Erreur serveur lors du chargement des travaux");
  }
};

  // 🔹 Récupération des données principales du locataire
  const fetchPersonData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`https://backend-ged-immo.onrender.com/detail/locataire/${id}`);
      const text = await res.text();
      const data = text ? JSON.parse(text) : { homeId: {}, rentals: [] };
      setPerson(data);

      // Documents
      const docRes = await fetch(`https://backend-ged-immo.onrender.com/locataire/${id}/documents`);
      if (docRes.ok) {
        const docData = await docRes.json();
        if (docData.success && docData.documents) setDocuments(docData.documents);
      }

      await fetchRents();
      await fetchWorks();
    } catch (err) {
      console.error("Erreur fetchPersonData:", err);
      toast.error("Impossible de récupérer les données du locataire");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchPersonData();
  }, [id]);

  const confirmDeleteWork = (workId) => {
  toast((t) => (
    <div style={{ textAlign: "center" }}>
      <p style={{ fontWeight: "bold" }}>⚠️ Voulez-vous vraiment supprimer ce travail ?</p>
      <div style={{ marginTop: "10px", display: "flex", justifyContent: "center", gap: "15px" }}>
        <button
          style={{
            background: "#ef4444",
            color: "#fff",
            padding: "6px 12px",
            borderRadius: "5px",
            fontWeight: "bold"
          }}
          onClick={async () => {
            try {
              const res = await fetch(`https://backend-ged-immo.onrender.com/works/${workId}`, {
                method: "DELETE",
              });
              const data = await res.json();

              if (res.ok && data.success) {
                setWorks((prev) => prev.filter((w) => w._id !== workId));
                toast.success("✅ Travail supprimé !");
              } else {
                toast.error(data.message || "Erreur lors de la suppression");
              }
            } catch (err) {
              console.error("Erreur suppression:", err);
              toast.error("Erreur serveur");
            }
            toast.dismiss(t.id);
          }}
        >
          Oui, supprimer
        </button>

        <button
          style={{
            background: "#6b7280",
            color: "#fff",
            padding: "6px 12px",
            borderRadius: "5px",
            fontWeight: "bold"
          }}
          onClick={() => toast.dismiss(t.id)}
        >
          Annuler
        </button>
      </div>
    </div>
  ), { duration: 8000 });
};

  return (
    <div>
      <NavbarLoc />
      <div className="detail-container">
        {loading ? (
          <p className="loading">Chargement des informations...</p>
        ) : (
          <div className="detail-wrapper" ref={componentRef}>
            <h2 className="title">
              {person.typePersonne === "particulier"
                ? `${person.name || ""} ${person.lastname || ""}`
                : person.raisonSociale || "Société N/A"}
            </h2>

            {/* Informations personnelles ou société */}
            <div className="section">
              <h3>Informations {person.typePersonne === "particulier" ? "personnelles" : "société"}</h3>
              <div className="info-grid">
                {person.typePersonne === "particulier" ? (
                  <>
                    <p><strong>Nom :</strong> {person.name || "N/A"}</p>
                    <p><strong>Prénom :</strong> {person.lastname || "N/A"}</p>
                    <p><strong>Date de naissance :</strong> {formatDate(person.birth)}</p>
                    <p><strong>Lieu :</strong> {person.lieu || "N/A"}</p>
                    <p><strong>Sexe :</strong> {person.sexe || "N/A"}</p>
                    <p><strong>Profession :</strong> {person.profession || "N/A"}</p>
                  </>
                ) : (
                  <>
                    <p><strong>Raison sociale :</strong> {person.raisonSociale || "N/A"}</p>
                    <p><strong>Responsable :</strong> {person.responsable || "N/A"}</p>
                    <p><strong>RCCM :</strong> {person.rccm || "N/A"}</p>
                    <p><strong>IFU :</strong> {person.ifu || "N/A"}</p>
                    <p><strong>Domaine activité :</strong> {person.domaineActivite || "N/A"}</p>
                    <p><strong>Siège social :</strong> {person.siegeSocial || "N/A"}</p>
                  </>
                )}

                {/* Champs communs */}
                <p><strong>Téléphone :</strong> {person.tel || "N/A"}</p>
                <p><strong>Email :</strong> {person.email || "N/A"}</p>
                <p><strong>Adresse :</strong> {person.address || "N/A"}</p>
                <p><strong>Ville :</strong> {person.city || "N/A"}</p>
                <p><strong>Pièce(s) d'identité(s) :</strong> {person.pieces || "N/A"}</p>
                <p><strong>Date émission :</strong> {formatDate(person.date_emission)}</p>
                <p><strong>Date expiration :</strong> {formatDate(person.date_expiration)}</p>
                <p><strong>Date entrée :</strong> {formatDate(person.date_entrance)}</p>
                <p><strong>Date sortie :</strong> {person.release_date || "N/A"}</p>
              </div>
            </div>

            {/* Logement */}
           <div className="section tenant-section">
  <h3 className="section-title">Logement attribué</h3>

  {person.homeId ? (
    <div
      className="home-card"
      style={{ display: "flex", flexWrap: "wrap", gap: "2rem" }}
    >
      {/* 🖼️ IMAGES */}
      <div
        className="home-images"
        style={{
          flex: "1 1 250px",
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        {/* Image principale */}
        {person.homeId.img && (
          <img
            src={
              person.homeId.img.startsWith("http")
                ? person.homeId.img
                : `https://backend-ged-immo.onrender.com/${person.homeId.img}`
            }
            alt="Logement principal"
            style={{
              width: "200px",
              height: "200px",
              objectFit: "cover",
              borderRadius: "10px",
              border: "2px solid #2563eb",
              cursor: "pointer",
            }}
            onClick={() =>
              window.open(
                person.homeId.img.startsWith("http")
                  ? person.homeId.img
                  : `https://backend-ged-immo.onrender.com/${person.homeId.img}`,
                "_blank"
              )
            }
          />
        )}

        {/* Images secondaires */}
        {Array.isArray(person.homeId.images) &&
          person.homeId.images.map((img, index) => (
            <img
              key={index}
              src={
                img.startsWith("http")
                  ? img
                  : `https://backend-ged-immo.onrender.com/${img}`
              }
              alt={`Secondaire ${index}`}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                cursor: "pointer",
              }}
              onClick={() =>
                window.open(
                  img.startsWith("http")
                    ? img
                    : `https://backend-ged-immo.onrender.com/${img}`,
                  "_blank"
                )
              }
            />
          ))}
      </div>

      {/* 📌 INFORMATIONS */}
      <div
        className="home-info"
        style={{
          flex: "2 1 400px",
          background: "#fff",
          padding: "1.5rem",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <h4>Informations générales</h4>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "1rem",
          }}
        >

          <p><strong>Nom :</strong> {person.homeId.nameHome || "N/A"}</p>
          <p><strong>Type :</strong> {person.homeId.nameHomeType || "N/A"}</p>
          <p><strong>Référence :</strong> {person.homeId.reference || "N/A"}</p>
          <p><strong>Catégorie :</strong> {person.homeId.categorie || "N/A"}</p>
          <p><strong>Sous-catégorie :</strong> {person.homeId.sousCategorie || "N/A"}</p>
          <p><strong>Adresse :</strong> {person.homeId.addressHome || "N/A"}</p>
          <p><strong>Ville :</strong> {person.homeId.city || "N/A"}</p>
          <p><strong>Quartier :</strong> {person.homeId.quarter || "N/A"}</p>
          <p><strong>Nombre de pièces :</strong> {person.homeId.NmbrePieces || "N/A"}</p>
          <p><strong>Loyer :</strong> {person.homeId.rent ? `${Number(person.homeId.rent).toLocaleString()} FCFA` : "N/A"}</p>
          <p><strong>Caution :</strong> {person.homeId.guarantee ? `${Number(person.homeId.guarantee).toLocaleString()} FCFA` : "N/A"}</p>
          <p><strong>Charges :</strong> {person.homeId.charges || "N/A"}</p>
          <p><strong>Statut :</strong> {person.homeId.state || "Occupé"}</p>
          <p style={{ gridColumn: "1 / -1" }}>
            <strong>Description :</strong> {person.homeId.description || "—"}
          </p>
        </div>

        {/* 🛠️ Équipements */}
        <h4 style={{ marginTop: "1rem" }}>Équipements & options</h4>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "0.8rem",
            background: "#f9fafb",
            padding: "1rem",
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
          }}
        >
          <p><strong>Terrasse :</strong> {person.homeId.terrasse ? "Oui" : "Non"}</p>
          <p><strong>Jardin :</strong> {person.homeId.jardin ? "Oui" : "Non"}</p>
          <p><strong>Balcon :</strong> {person.homeId.balcon ? "Oui" : "Non"}</p>
          <p><strong>Piscine :</strong> {person.homeId.piscine ? "Oui" : "Non"}</p>
          <p><strong>Garage :</strong> {person.homeId.garage ? "Oui" : "Non"}</p>
          <p><strong>Sécurité :</strong> {person.homeId.serviceSecurite ? "Oui" : "Non"}</p>
        </div>
      </div>
    </div>
  ) : (
    <p>Aucun logement attribué</p>
  )}
</div>

            {/* Accès */}
            <div className="tenant-section">
              <h3 className="section-title">Accès</h3>
              <div className="info-grid">
                <p><span>Username :</span> {person.username || "N/A"}</p>
                <p><span>Password :</span> {person.password || "N/A"}</p>
              </div>
            </div>

                {/* Paiements */}
           <div className="section">
  <h3>Historique des paiements</h3>

  {person.rentals && person.rentals.length > 0 ? (
    <div className="table-wrapper">
      {/* --- Desktop Table --- */}
      <table className="table-payments desktop-table">
        <thead>
          <tr>
            <th>📅 Date de paiement</th>
            <th>🗓️ Mois</th>
            <th>💰 Montant</th>
            <th>💳 Mode</th>
            <th>📄 Statut</th>
            <th>🔢 N° Reçu</th>
            <th>🖨️ Action</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const groupedByYear = person.rentals.reduce((groups, rent) => {
              const year = rent.month ? new Date(rent.month).getFullYear() : "Inconnue";
              if (!groups[year]) groups[year] = [];
              groups[year].push(rent);
              return groups;
            }, {});

            return Object.keys(groupedByYear)
              .sort((a, b) => b - a)
              .map((year) => (
                <React.Fragment key={year}>
                  <tr
                    onClick={() =>
                      setOpenYears((prev) => ({ ...prev, [year]: !prev[year] }))
                    }
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      background: "#f0f4ff",
                      color: "#2563eb",
                    }}
                  >
                    <td colSpan={7}>
                      {openYears[year] ? "▼" : "▶"} Paiements de l’année {year}
                    </td>
                  </tr>

                  {openYears[year] &&
                    groupedByYear[year]
                      .sort((a, b) => new Date(b.month) - new Date(a.month))
                      .map((r) => (
                        <tr key={r._id}>
                          <td data-label="Date de paiement">
                            {r.date_of_payment
                              ? new Date(r.date_of_payment).toLocaleDateString("fr-FR")
                              : "N/A"}
                          </td>
                          <td data-label="Mois">
                            {r.month
                              ? new Date(r.month).toLocaleString("default", {
                                  month: "long",
                                  year: "numeric",
                                })
                              : "N/A"}
                          </td>
                          <td data-label="Montant">
                            {r.amount ? `${r.amount.toLocaleString()} FCFA` : "N/A"}
                          </td>
                          <td data-label="Mode">{r.mode || "N/A"}</td>
                          <td data-label="Statut">{r.status || "N/A"}</td>
                          <td data-label="N° Reçu">
                            {r.receipt_number || r.numero_recu || "—"}
                          </td>
                          <td data-label="Action">
                            <Link to={`/Mon__recu/fr/${r._id}`} title="Imprimer le reçu">
                              <i
                                className="fa-solid fa-print"
                                style={{ color: "#4f46e5" }}
                              ></i>
                            </Link>
                          </td>
                        </tr>
                      ))}
                </React.Fragment>
              ));
          })()}
        </tbody>
      </table>

      {/* --- Mobile Accordion --- */}
      <div className="mobile-accordion">
        {(() => {
          const groupedByYear = person.rentals.reduce((groups, rent) => {
            const year = rent.month ? new Date(rent.month).getFullYear() : "Inconnue";
            if (!groups[year]) groups[year] = [];
            groups[year].push(rent);
            return groups;
          }, {});

          return Object.keys(groupedByYear)
            .sort((a, b) => b - a)
            .map((year) => (
              <div key={year} className="year-accordion">
                <div
                  className="year-header"
                  onClick={() =>
                    setOpenYears((prev) => ({ ...prev, [year]: !prev[year] }))
                  }
                >
                  {openYears[year] ? "▼" : "▶"} Paiements de l’année {year}
                </div>
                {openYears[year] &&
                  groupedByYear[year]
                    .sort((a, b) => new Date(b.month) - new Date(a.month))
                    .map((r) => (
                      <div key={r._id} className="payment-card">
                        <p>
                          <strong>Date paiement :</strong>{" "}
                          {r.date_of_payment
                            ? new Date(r.date_of_payment).toLocaleDateString("fr-FR")
                            : "N/A"}
                        </p>
                        <p>
                          <strong>Mois :</strong>{" "}
                          {r.month
                            ? new Date(r.month).toLocaleString("default", {
                                month: "long",
                                year: "numeric",
                              })
                            : "N/A"}
                        </p>
                        <p>
                          <strong>Montant :</strong>{" "}
                          {r.amount ? `${r.amount.toLocaleString()} FCFA` : "N/A"}
                        </p>
                        <p>
                          <strong>Statut :</strong> {r.status || "N/A"}
                        </p>
                        <p>
                          <strong>N° Reçu :</strong>{" "}
                          {r.receipt_number || r.numero_recu || "—"}
                        </p>
                        <Link
                          to={`/Mon__recu/fr/${r._id}`}
                          title="Imprimer le reçu"
                          style={{
                            padding: "4px 8px",
                            borderRadius: "5px",
                            background: "#2563eb",
                            color: "white",
                            textDecoration: "none",
                            display: "inline-block",
                            marginTop: "4px",
                            textAlign: "center",
                          }}
                        >
                          🖨️ Imprimer
                        </Link>
                      </div>
                    ))}
              </div>
            ));
        })()}
      </div>
    </div>
  ) : (
    <p>Aucun paiement trouvé</p>
  )}

  <style>{`
    .table-wrapper {
      overflow-x: auto;
    }

    /* Desktop table */
    .desktop-table {
      width: 100%;
      border-collapse: collapse;
    }
    .desktop-table th,
    .desktop-table td {
      border: 1px solid #ddd;
      padding: 6px 8px;
      text-align: center;
      font-size: 0.85rem;
    }
    .desktop-table th {
      background: #f1f5f9;
      font-weight: 600;
    }

    /* Mobile accordion */
    .mobile-accordion {
      display: none;
    }
    .year-accordion {
      margin-bottom: 10px;
      border: 1px solid #ddd;
      border-radius: 8px;
      overflow: hidden;
    }
    .year-header {
      background: #f0f4ff;
      color: #2563eb;
      font-weight: bold;
      padding: 8px 12px;
      cursor: pointer;
    }
    .payment-card {
      background: #fff;
      padding: 8px 12px;
      border-top: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    @media (max-width: 480px) {
      .desktop-table {
        display: none;
      }
      .mobile-accordion {
        display: block;
      }
    }
  `}</style>
</div>

            {/* Documents */}
            <div className="section">
              <h3>Documents</h3>
              <div className="doc-grid">
                <p><strong>Carte d’identité :</strong> {documents.CNI ? <a href={`https://backend-ged-immo.onrender.com/${documents.CNI}`} target="_blank">Voir</a> : "Aucun document"}</p>
                <p><strong>Contrat de bail :</strong> {documents.Contrat ? <a href={`https://backend-ged-immo.onrender.com/${documents.Contrat}`} target="_blank">Voir</a> : "Aucun document"}</p>
              </div>
            </div>

{/* 🔹 Travaux et demandes de réparation */}
 <div className="tenant-section">
      <h3 className="section-title">🛠️ Travaux et demandes de réparation</h3>

      <div className="works-list">
        {works.length === 0 ? (
          <p>Aucun travail ou demande enregistrée</p>
        ) : (
          works.map((work, index) => {
            const isOpen = openIndex === index;

            return (
              <div key={work._id} className="work-card">
                {/* 🔹 En-tête cliquable */}
                <div
                  className="work-header"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "#f3f4f6",
                    borderRadius: "6px",
                    padding: "10px 12px",
                  }}
                >
                  <p style={{ fontWeight: "600", margin: 0 }}>
                    {work.title || "Travail sans titre"}
                  </p>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <span
                      style={{
                        color:
                          work.status === "Accepté" || work.status === "Terminé"
                            ? "#16a34a"
                            : work.status === "Refusé"
                            ? "#dc2626"
                            : "#f59e0b",
                        fontWeight: "bold",
                      }}
                    >
                      {work.status || "En attente"}
                    </span>
                    <i
                      className={`fa-solid ${
                        isOpen ? "fa-chevron-up" : "fa-chevron-down"
                      }`}
                      style={{ color: "#2563eb" }}
                    ></i>
                  </div>
                </div>

                {/* 🔹 Contenu dépliant */}
                <div
                  className="accordion-content"
                  style={{
                    maxHeight: isOpen ? "600px" : "0",
                    overflow: "hidden",
                    transition: "max-height 0.3s ease",
                    background: "#fff",
                    borderRadius: "0 0 8px 8px",
                    padding: isOpen ? "10px 15px" : "0 15px",
                  }}
                >
                  {isOpen && (
                    <>
                      <p>
                        <strong>Description :</strong>{" "}
                        {work.description || "Aucune description"}
                      </p>

                      {work.cost > 0 && (
                        <p>
                          <strong>Coût :</strong>{" "}
                          {work.cost.toLocaleString()} FCFA
                        </p>
                      )}

                      <p>
                        <strong>Date :</strong> {formatDate(work.createdAt)}
                      </p>

                      {work.adminResponse && (
                        <p>
                          <strong>Réponse du propriétaire :</strong>{" "}
                          {work.adminResponse}
                        </p>
                      )}

                      {work.adminComment && (
                        <p>
                          <strong>Note interne :</strong> {work.adminComment}
                        </p>
                      )}

                      {/* 🖼️ Images jointes */}
                      {work.attachments?.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexWrap: "wrap",
                            marginTop: "8px",
                          }}
                        >
                          {work.attachments.map((url, i) => (
                            <img
                              key={i}
                              src={
                                url.startsWith("http")
                                  ? url
                                  : `https://backend-ged-immo.onrender.com/${url}`
                              }
                              alt={`Pièce jointe ${i + 1}`}
                              style={{
                                width: "70px",
                                height: "70px",
                                borderRadius: "6px",
                                objectFit: "cover",
                                border: "1px solid #e5e7eb",
                              }}
                            />
                          ))}
                        </div>
                      )}

                      {/* 📄 Facture PDF */}
                      {work.invoice && (
                        <div style={{ marginTop: "10px" }}>
                          <a
                            href={
                              work.invoice.startsWith("http")
                                ? work.invoice
                                : `https://backend-ged-immo.onrender.com/${work.invoice}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            style={{
                              display: "inline-block",
                              padding: "6px 12px",
                              background: "#2563eb",
                              color: "white",
                              borderRadius: "6px",
                              textDecoration: "none",
                              fontWeight: "500",
                            }}
                          >
                            📄 Télécharger la facture
                          </a>
                        </div>
                      )}

                      {/* 🗑️ Bouton suppression */}
                      {/* <button
                        onClick={() => confirmDeleteWork(work._id)}
                        style={{
                          marginTop: "12px",
                          background: "#dc2626",
                          color: "white",
                          border: "none",
                          borderRadius: "6px",
                          padding: "6px 10px",
                          cursor: "pointer",
                        }}
                      >
                        🗑️ Supprimer
                      </button> */}
                    </>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* 🔹 BOUTON SIGNALER UN PROBLÈME */}
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <button
            onClick={toggleModal}
            style={{
              background: "#dc2626",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            🚧 Signaler un problème / réparation
          </button>
        </div>
    </div>

        


        {/* 🔹 BOUTON SIGNALER UN PROBLÈME */}
        {/* <div style={{ textAlign: "center", marginTop: "30px" }}>
          <button
            onClick={toggleModal}
            style={{
              background: "#dc2626",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            🚧 Signaler un problème / réparation
          </button>
        </div> */}

        {/* 🔹 MODAL DE SIGNALISATION */}
        {showWorkModal && (
          <div className="modal-overlay-repairs">
            <div className="modal-repairs">
              <h3>🛠️ Nouvelle demande de réparation</h3>
              <form onSubmit={handleSubmitWork}>
                <div className="form-group">
                  <label>Titre du problème :</label>
                  <input
                    type="text"
                    value={workForm.title}
                    onChange={(e) => setWorkForm({ ...workForm, title: e.target.value })}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Description :</label>
                  <textarea
                    rows="4"
                    value={workForm.description}
                    onChange={(e) =>
                      setWorkForm({ ...workForm, description: e.target.value })
                    }
                  ></textarea>
                </div>

                <div className="form-group">
                  <label>Ajouter des photos (max 3) :</label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFileChange}
                  />
                  <div className="preview-container">
                    {workForm.attachments.length > 0 &&
                      workForm.attachments.map((file, i) => (
                        <img
                          key={i}
                          src={URL.createObjectURL(file)}
                          alt="preview"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginRight: "10px",
                          }}
                        />
                      ))}
                  </div>
                </div>

                <div className="modal-actions">
                  <button type="button" onClick={toggleModal} className="cancel-btn">
                    Annuler
                  </button>
                  <button type="submit" className="submit-btn">
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

            {/* <button className="print-btn" onClick={handlePrint}>🖨️ Imprimer</button> */}
          </div>
        )}
      </div>
      <Footer />

      <style>{`
        /* Conteneur général */
.detail-container {
  padding: 0.7rem;
  background: #f8fafc;
}

/* Wrapper principal */
.detail-wrapper {
  background: #fff;
  border-radius: 10px;
  padding: 0.8rem;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
  max-width: 100%;
  overflow-x: hidden;
}

/* Titre */
.title {
  color: #1e3a8a;
  margin-bottom: 20px;
  font-size: 1.5rem;
  font-weight: 600;
}

/* Sections */
.section {
  margin-bottom: 2rem;
}

/* Grid informations locataire / société */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
}

.info-grid p {
  background: #f9fafb;
  padding: 8px;
  border-radius: 5px;
  font-size: 0.875rem;
}

/* Logement */
.home-card {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.home-images {
  flex: 1 1 200px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.home-images img {
  width: 100%;
  max-width: 200px;
  height: auto;
  border-radius: 10px;
  border: 2px solid #2563eb;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.home-images img:hover {
  transform: scale(1.05);
}

.home-info {
  flex: 2 1 300px;
  background: #fff;
  padding: 0.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.home-info h4 {
  margin-bottom: 10px;
  color: #1e3a8a;
  font-size: 1.1rem;
}

/* Équipements & options */
.home-info .equipment-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.8rem;
  background: #f9fafb;
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.home-info .equipment-grid p {
  background: none;
  padding: 0;
}

/* Accès */
.tenant-section .info-grid {
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}

/* Tableau Paiements */
.table-wrapper {
  overflow-x: auto;
  margin-top: 10px;
}

.table {
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.table th, .table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.table th {
  background: #f1f5f9;
  font-weight: 600;
}

/* Travaux */
.works-list {
  display: grid;
  gap: 10px;
}

.work-card {
  background: #f9f9f9;
  padding: 10px;
  border-radius: 8px;
  border-left: 4px solid #2563eb;
  overflow: hidden;
}

.work-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
  background: #f3f4f6;
  border-radius: 6px;
  padding: 10px 12px;
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #fff;
  border-radius: 0 0 8px 8px;
  padding: 0 15px;
}

/* Modal */
.modal-overlay-repairs {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-repairs {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  overflow-y: auto;
  max-height: 90vh;
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  font-weight: 600;
}

.form-group input,
.form-group textarea {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px;
  font-size: 0.9rem;
}

/* Boutons */
.print-btn,
.submit-btn,
.cancel-btn {
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 0.9rem;
  margin-top: 10px;
  transition: background 0.2s ease;
}

.print-btn:hover,
.submit-btn:hover,
.cancel-btn:hover {
  background: #1e40af;
}

/* Responsive Media Queries */
@media (max-width: 768px) {
  .info-grid,
  .home-info > div,
  .equipment-grid {
    grid-template-columns: 1fr; /* une seule colonne */
  }

  .home-card {
    flex-direction: column;
  }

  .home-images {
    justify-content: center;
  }

  .home-info {
    flex: 1 1 100%;
  }

  .table {
    font-size: 0.75rem;
  }

  .print-btn,
  .submit-btn,
  .cancel-btn {
    width: 100%;
    padding: 12px;
    font-size: 0.85rem;
  }

  .work-card {
    padding: 8px;
  }

  .accordion-content {
    padding: 5px 10px;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 1.2rem;
  }

  .home-images img {
    max-width: 100%;
    height: auto;
  }

  .home-info h4 {
    font-size: 1rem;
  }

  .table {
    font-size: 0.7rem;
  }
}
      `}</style>
    </div>
  );
}